import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

$.extend(uly.actions, {
    "entityreport":function(ev, $elt, ui) {
        var bound_entity = uly.utils.get_bound_entity($elt);
        if (!bound_entity) {
            bound_entity = {};
        }
        var entity = null;
        if (ko.unwrap(bound_entity.type)) {
            entity = ko.unwrap(bound_entity.type);
        }
        uly.dialogs.lookup_value(
            "birtreport", _("report_actions_select_a_report", "Select a report"), _("report_actions_report", "Report"), _("report_actions_select", "Select"), _("report_actions_cancel", "Cancel"), {"filters":"(entity=\\'"+entity +"\\')"}
        ).done(function(report){
            var url = null;
            if (report.id && report.__link){
                url = report.__link;
            }
            else if (report.unique_id) {
                url = report.unique_id.replace("#","/");
            }
            else return uly.utils.show_results({ "success":false, "error":_("report_actions_error_no_valid_report_selected", "No valid report selected") });

            console.log("entityreport:", ev, ui, report);
            ui.bindingContext.grid_state_model.selected_row_data().done(function(selected_rows){
                console.log("selected rows:", selected_rows, "ev:", ev, "ui:", ui);
                if (null != ui) {
                    $.each(selected_rows, function(i, row) {
                        if(row)
                            url = url + (i ? "&" : "?") + "rparams.id=" + row.id;
                    });
                    console.log("Birt Report redirecting: " + url);
                    Crimson.net.goTo(url);
                }
            }).fail(function(result, ev, ui){
                uly.utils.show_results({ "success":false, "error":_("report_actions_error_unable_to_handle_selection_on_the_grid", "Unable to handle selection on the grid") });
            });
        }).fail(function(result, ev, ui){
            uly.utils.show_results({ "success":false, "error":_("report_actions_error_cannot_search_for_the_related_report", "Cannot search for the related report.") });
        });
    },
    "singleentityreport": function(ev, $elt, ui) {
        var bound_entity = uly.utils.get_bound_entity($elt);
        if (!bound_entity) {
            bound_entity = {};
        }
        var entity = bound_entity.type_name.toLowerCase();
        var _id = bound_entity.id;
        console.log("trying to get the report stuff for: entity: ", entity, "id", _id, "ev:", ev, "ui:", ui);
        uly.dialogs.lookup_value(
            "birtreport", _("report_actions_select_a_report", "Select a report"), _("report_actions_report", "Report"), _("report_actions_select", "Select"), _("report_actions_cancel", "Cancel"), {"filters":"(entity=\\'"+ entity +"\\')"}
        ).done(function(report){
            console.log("got report:", report);
            if (report.id && report.__link){
                console.log("Birt Report redirecting: " + report.__link + "?id=" + _id);
                uly.actions.navigateto(report.__link + "?rparams.id=" + _id);
            } else if (report.unique_id) {
                uly.actions.navigateto(report.unique_id.replace("#","/")+"?rparams.id="+_id);
            }else
                uly.utils.show_results({"success":false, "error":_("report_actions_error_no_report_selected", "No report selected") });
        }).fail(function(result, ev, ui){
            uly.utils.show_results(result);
        });
    }
});
